import gql from 'graphql-tag'

export const QUERY = gql`
  query course_homeworks_index($page: Int!, $perPage: Int!) {
    courseHomeworks(page: $page, perPage: $perPage) {
      nodes {
        id
        title
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
`
